import { Alert, Spin } from "antd";
import { useTranslation } from "react-i18next";
import {
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { getAdaptiveTickFormatter, SeriesDefinition } from "./Chart";

interface SingleChartProps {
  seriesDefintion: SeriesDefinition;
  isLoading: boolean;
  alertMessage?: string;
  height?: string;
}

export function SingleAxisChart({
  seriesDefintion,
  isLoading,
  alertMessage,
  height = "100%",
}: SingleChartProps) {
  const { t } = useTranslation();

  if (isLoading) {
    return <Spin className="centered" />;
  }
  if (seriesDefintion.dataSet?.length === 0) {
    return (
      <div style={{ height: "100%", position: "relative" }}>
        <Alert
          message={alertMessage ? alertMessage : t("no-data")}
          type="info"
          showIcon
        />
      </div>
    );
  }
  return (
    <div
      data-testid="single-axis-chart"
      style={{ width: "100%", height: "100%" }}
    >
      <ResponsiveContainer width="100%" height={height}>
        <LineChart
          data={seriesDefintion.dataSet}
          margin={{ top: 20, right: 50, left: 20, bottom: 20 }}
        >
          <XAxis
            dataKey="ts"
            type="number"
            domain={["auto", "auto"]}
            scale="time"
            tickFormatter={getAdaptiveTickFormatter(seriesDefintion.dataSet)}
            tickCount={5}
            interval="preserveStartEnd"
          />
          <YAxis domain={["auto", "auto"]} yAxisId="left" />
          <Tooltip
            labelFormatter={(ts) => new Date(ts).toLocaleString()}
            formatter={(value: number) => value.toFixed(2)}
          />
          <Legend iconType="plainline" />
          <Line
            yAxisId="left"
            type="linear"
            dataKey="value"
            stroke={seriesDefintion.color}
            name={seriesDefintion.name}
            dot={false}
            isAnimationActive={false}
            strokeWidth={2}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
